import { render, staticRenderFns } from "./EditMyProfileForm.vue?vue&type=template&id=27020e81"
import script from "./EditMyProfileForm.vue?vue&type=script&lang=js"
export * from "./EditMyProfileForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports